import SidebarFloatingAd from 'components/ad/SidebarFloatingAd'
import NC from 'nc/NC'
import React from 'react'
import TopBanner from 'shared-components/ad/TopBanner'
import { useAffilate } from 'shared-components/hooks/use-affilate'
import { useTaglessAd } from 'shared-components/hooks/use-tagless-ad'
import PostNavigation from 'shared-components/layout/PostNavigation'
import styleUtils from 'shared-components/styles/util.module.css'
import AdaptiveThreeColumnLayout from 'shared-components/ui/AdaptiveThreeColumnLayout'
import BestList from 'shared-components/ui/BestList'
import BreadCrumbs from 'shared-components/ui/BreadCrumbs'
import Disclaimer from 'shared-components/ui/Disclaimer'
import PostShortLine from 'shared-components/ui/PostShortLine'
import PostTags from 'shared-components/ui/PostTags'
import PostTitle from 'shared-components/ui/PostTitle'
import PromotedCard from 'shared-components/ui/PromotedCard'
import SidedCategoryMenu from 'shared-components/ui/SidedCategoryMenu'
import SplitterLine from 'shared-components/ui/SplitterLine'
import { DSBestListPageAA } from 'types.aa.ds'
import stylesCommon from './PostTemplate.ReviewTemplate.module.css'
import styles from './PostTemplate.module.css'
import ArticleConversation from 'shared-components/comments/conversation/ArticleConversation'
import ConversationRailCard from 'shared-components/comments/conversation/ConversationRailCard'
import UnderTitleAds from 'components/ad/UnderTitleAds'

interface BestListTemplateProps {
  page: DSBestListPageAA
}

const BestListTemplate: React.VFC<BestListTemplateProps> = ({ page }) => {
  useTaglessAd()
  useAffilate(page.productBars)

  return (
    <>
      <Disclaimer />
      <div className={styleUtils.wrapper}>
        <BreadCrumbs list={page.breadcrumbs} className={stylesCommon.breadCrumbs} />
        <PostTitle title={page.title} subtitle={page.subtitle} />
        <PostShortLine post={page} className={styles.shortLine} />
        <TopBanner />
        <UnderTitleAds ads={page.underTitleAds} />
        {page.promotedProduct ? <PromotedCard data={page.promotedProduct} /> : null}
        <SplitterLine className={styles.splitter} />
        <BestList bestList={page.bestList} cardScoreVariant="stars" />
        <AdaptiveThreeColumnLayout
          left={
            page.sideMenu.length ? (
              <SidedCategoryMenu
                className={stylesCommon.sidebarPostNav}
                title="Go deeper"
                menu={page.sideMenu}
              />
            ) : null
          }
          className={styles.content}
          content={
            <>
              {page.blocks.map((item, index) => (
                <NC key={index + 1} data={item} tpl="text" index={index} />
              ))}

              <PostTags meta={page.meta} className={stylesCommon.postTags} />

              {page.meta.engagementContainerId ? (
                <ArticleConversation className={stylesCommon.comments} />
              ) : null}
            </>
          }
          sidebar={
            <PostNavigation>
              {[...page.sidebarContent, ...page.sidebarAds].map((item, index) => (
                <NC key={index} data={item} tpl="sidebar" index={index} />
              ))}
              {/* After every WordPress sidebar widget (the trust box arrives in sidebarAds as an
                  nc-multi), before the sticky Playwire ads: the widgets scroll away above the card and
                  never pass under the stuck strip; the ads still pin under it. */}
              <ConversationRailCard />
              <SidebarFloatingAd />
            </PostNavigation>
          }
        />
        {/* <RecommendAA
          containerClassName={stylesCommon.related}
          itemClassName={styleRelatedCard.relatedCard}
          title="More from Android Authority"
        /> */}
      </div>
    </>
  )
}

export default BestListTemplate
